<template>
  <div id="app">
<!--    <transition :name="transitionName">-->
      <keep-alive include="editinfo">
        <router-view/>
      </keep-alive>
<!--    </transition>-->
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {
      transitionName: ''
    }
  },
  // vue监听路由对象$route的方法
  watch: {
    // watch $route 决定使用哪种过渡
    '$route' (to, from) {
      if (to.meta.index === null || from.name === null) {
        this.transitionName = ''
      } else {
        if (to.meta.index > from.meta.index) {
        // 设置动画名称
          this.transitionName = 'slide-left'
        } else {
          this.transitionName = 'slide-right'
        }
      }
    }
  }
}
</script>
<style lang="stylus">
#app {
  .slide-right-enter-active,
  .slide-right-leave-active,
  .slide-left-enter-active,
  .slide-left-leave-active {
  will-change: transform;
    transition: all 500ms;
    position: absolute;
  }
  .slide-right-enter {
  opacity: 0;
  // transform: translate3d(-100%, 0, 0);
  }
  .slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
  }
  .slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
  }
  .slide-left-leave-active {
  opacity: 0;
  // transform: translate3d(-100%, 0, 0);
  }
}
</style>
